<template>
<section class="height100vh" style="padding-top:0;height: calc(100vh - 68px);">
    <div class="wrap">
        <ul class="reservation_data">
            <li>
                <button 
                    :class="{ 'open' :(show == date) }"
                    @click="showChange(date)"
                >
                    {{selectedDateShow}} 
                    <img :src="resource.imgIconArrowOpen">
                </button>
                <div class="box" style="display: block;" v-if="show == date">
                    <DatePicker 
                        v-model="selectedDate"
                        :min-date="minSelectedDate"
                        :max-date="maxSelectedDate"
                        is-expanded
                    />
                </div>
            </li>
            <li>
                <button 
                    :class="{ 'open' :(show == time) }"
                    @click="showChange(time)"
                    :disabled="selectedDate==null"
                >
                    {{selectedTimeShow}} 
                    <img :src="resource.imgIconArrowOpen">
                </button>
                <div class="box box1" style="display:block;" v-if="show == time">
                    <ul class="time_pick_ul">
                        <li>
                            <p>오전</p>
                            <div>
                                <!-- class="not" -->
                                <span 
                                    v-for="(am, idx) in ams" 
                                    :key="`am-${idx}`" 
                                    :class="{
                                        'pick' : (selectedTime == am),
                                        'not': !isAbledTime(am) }"
                                    @click="setSelectedTime(am)"
                                >
                                    {{dayjsTimeformat(am)}}
                                </span>
                            </div>
                        </li>
                        <li>
                            <p>오후</p>
                            <div>
                                <span 
                                    v-for="(pm,idx) in pms" :key="`pm-${idx}`"
                                    :class="{
                                        'pick' : (selectedTime == pm),
                                        'not' : !isAbledTime(pm) }"
                                    @click="setSelectedTime(pm)"
                                >
                                    {{dayjsTimeformat(pm)}}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>    
        </ul>
    </div>

    <button class="default_fixed_btn" @click="next()">다음</button>
</section>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    name:'BookingInputDate',
    components: {
        DatePicker,
    },
    data() {
        return {

            date: 'date',
            time: 'time',

            show: 'date',

            selectedDate: null,
            selectedTime: null,

            ams:[],
            pms:[],
        }
    },
    
    created () {
        this.$store.commit('SHOW_ONLOAD');
    },

    computed: {
        ...mapState(["resource"]),
        ...mapState({
            bookingWrite: state => state.booking.itemWrite,
            business: state => state.shop.business
        }),
        
        bookingId(){
            return Number(this.$route.params.bookingId);
        },

        routerPath() {
            let path = '/booking/scRecommendResult';
            return (this.bookingId) ? `${path}/${this.bookingId}`: path;
        },

        minSelectedDate() {
            return new Date();
        },
        maxSelectedDate() {
            let date = new Date();
            date.setDate(date.getDate() + 15);
            return date;
        },
        selectedDateShow() {
            return (this.selectedDate) ? dayjs(this.selectedDate).format("YYYY-MM-DD") : '날짜 선택' ;
        },

        selectedTimeShow() {
            return (this.selectedTime) ? this.dayjsTimeformat(this.selectedTime, "h:mm A") : '시간 선택' ;
        },
    },
    watch: {
        selectedDate(value) {
            this.selectedTime = null;
            this.$store.dispatch(
                'GET_SHOP_BUSINESS',
                {
                    searchDate: dayjs(value).format("YYYY-MM-DD"),
                    trimId: this.bookingWrite.trimId
                }
            )
            .then((data) => {
                this.setAmsPms(data);
                this.show = this.time;
            })
        }
    },
    methods: {
        next() {
            if(!this.selectedDate) 
                return this.$store.commit('OPEN_MODAL', { content:'날짜를 선택해주세요', btnOne:'확인', })

            if(!this.selectedTime) 
                return this.$store.commit('OPEN_MODAL', { content:'시간을 선택해주세요', btnOne:'확인', })

            this.bookingWrite.bookingDt = dayjs(this.selectedDate).format("YYYY-MM-DD") + " " + this.selectedTime;
            this.$router.push(this.routerPath);
        },

        showChange(type){
            if(this.show == type)  return this.show = '';
            return this.show = type;
        },

        isAbledTime(time) {
            let result = false;

            let selectedDate = this.selectedDateShow;
            let today = dayjs().format("YYYY-MM-DD");
            let minute = dayjs().format("mm") < 30 ? 0 : 30;
            let todayLimit = dayjs().add(1, 'hour').minute(minute);
            let selectedTime = dayjs(today+" "+time);

            if(selectedDate == today && selectedTime < todayLimit) {
                result = false;
            }
            else {
                result = true;
            }

            return result;
        },

        dayjsTimeformat(time, format="h:mm") {
            return dayjs(dayjs().format("YYYY-MM-DD") + " " + time).format(format);
        },

        setSelectedTime(value) {
            let checkTime = this.isAbledTime(value);

            if(checkTime)
                this.selectedTime = value;
        },

        setAmsPms(data) {
            let noon = dayjs().hour(12).minute(0);
            let today = dayjs().format("YYYY-MM-DD");
            let startTime = dayjs(today+" "+data.startTime);
            let endTime = dayjs(today+" "+data.endTime);
            let time = "";

            let ams = [];
            let pms = [];

            while(startTime < endTime) {
                time = startTime.format("HH:mm");
                startTime = startTime.add(30, 'minute');

                startTime<noon ? ams.push(time) : pms.push(time);
            }

            time = startTime.format("HH:mm");
            startTime<noon ? ams.push(time) : pms.push(time);

            this.ams = ams;
            this.pms = pms;
        }
    },
}
</script>

<style scoped>
button:disabled {
    opacity: 0.5;
}
</style>